import { connect } from 'react-redux'
import Onboard from './components/Onboard/Onboard'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ onboard: state.onboard }), mapDispatchToProps)(Onboard)
